/* Stealth replacement parts page.
   Reads the JSON blob the section emits, renders the edition picker,
   the handle identifier and the parts grid, and posts one multi-line
   add to the cart. Requests, back-in-stock notes and interest
   registrations all reuse the native contact form at the foot. */
(function () {
  'use strict';

  var node = document.getElementById('rp-data');
  if (!node) return;
  var DATA;
  try { DATA = JSON.parse(node.textContent); } catch (e) { return; }
  if (!DATA.editions || !DATA.editions.length) return;

  var GROUP_ORDER = ['Handle assembly', 'Base assembly', 'Weight plates', 'Inserts', 'Other parts'];
  var $ = function (id) { return document.getElementById(id); };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  };

  function money(cents) {
    if (cents == null) return 'Price TBC';
    var fmt = DATA.money_format || '£{{amount}}';
    var n = cents / 100;
    function withCommas(v, dp) {
      var parts = v.toFixed(dp).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      if (name === 'amount_no_decimals') return withCommas(n, 0);
      if (name === 'amount_with_comma_separator') return withCommas(n, 2).replace(/,/g, ' ').replace('.', ',');
      return withCommas(n, 2);
    });
  }

  var GENS = (DATA.generations || '').split('\n').map(function (line) {
    var bits = line.split('|');
    if (bits.length < 2) return null;
    var mm = parseInt(bits[1], 10);
    if (!bits[0].trim() || !mm) return null;
    return { b: bits[0].trim(), mm: mm };
  }).filter(Boolean);

  var edIndex = 0, tab = 'gen', verdict = null, genPick = null;
  var qty = {}, cart = {}, META = {};
  var ed = function () { return DATA.editions[edIndex]; };

  /* After picking an edition, take the customer to the next question rather
     than leaving them to find it. Honours reduced-motion, and offsets by the
     theme's sticky header so the heading is not hidden underneath it. */
  function scrollToStep(el) {
    if (!el || typeof el.getBoundingClientRect !== 'function') return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var offset = 0;
    var candidates = document.querySelectorAll('sticky-header, .header-wrapper, header, #shopify-section-header');
    Array.prototype.forEach.call(candidates, function (h) {
      var pos = window.getComputedStyle(h).position;
      if (pos === 'sticky' || pos === 'fixed') offset = Math.max(offset, h.offsetHeight || 0);
    });
    var y = el.getBoundingClientRect().top + (window.pageYOffset || 0) - offset - 12;
    if (y < 0) y = 0;
    try { window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' }); }
    catch (e) { window.scrollTo(0, y); }
  }

  /* ---------- edition picker ---------- */
  function renderEds() {
    $('rp-eds').innerHTML = DATA.editions.map(function (v, i) {
      var req = v.request || !v.parts.length;
      var sel = i === edIndex;
      var flag = sel ? '<span class="rp-flag">Selected</span>'
                     : (req ? '<span class="rp-flag">By request</span>' : '');
      return '<button class="rp-ed" type="button" data-ed="' + i + '" aria-pressed="' + sel + '">'
        + (v.shot ? '<img class="rp-shot" src="' + esc(v.shot) + '" alt="' + esc(v.label) + '" loading="lazy">'
                  : '<span class="rp-shot"></span>')
        + flag
        + '<span class="rp-cap"><b>' + esc(v.label) + '</b><span>'
        + esc(v.sub || '')
        + (req ? (v.sub ? ' / ' : '') + 'parts by request' : '')
        + '</span></span></button>';
    }).join('');
    Array.prototype.forEach.call($('rp-eds').querySelectorAll('[data-ed]'), function (b) {
      b.addEventListener('click', function () {
        edIndex = parseInt(b.dataset.ed, 10);
        verdict = null; genPick = null;
        renderEds(); renderGrid(); renderPanel();
        var v = ed();
        var byRequest = v.request || !v.parts.length;
        scrollToStep($(byRequest ? 'rp-parts-stage' : 'rp-id-stage'));
      });
    });
  }

  /* ---------- parts grid ---------- */
  function chip(p) {
    return p.avail ? '<span class="rp-chip rp-in">In stock</span>'
                   : '<span class="rp-chip rp-out">Out of stock</span>';
  }
  function stateText(p) {
    return p.avail ? 'In stock' : 'Out of stock';
  }
  function syncStages() {
    var req = ed().request || !ed().parts.length;
    var st = $('rp-id-stage');
    if (st) st.hidden = req;
    renderBar();
  }
  function renderGrid() {
    var v = ed(), g = $('rp-grid');
    syncStages();
    $('rp-grid-title').textContent = 'Choose your ' + v.label + ' parts';
    if (v.request || !v.parts.length) {
      $('rp-grid-hint').textContent = DATA.copy.step3_request_hint || '';
      /* A by-request edition (Core) has no parts product on purpose. An edition
         that is NOT by-request but arrives with no parts means its product is
         unpublished or empty for now, so say the list is briefly unavailable
         rather than reading as a permanent product decision. */
      g.innerHTML = v.request
        ? '<div class="rp-note">We do not hold a full parts list for the ' + esc(v.label)
          + ' yet. We do keep limited spares, and we would much rather find you something than leave you '
          + 'with a dumbbell you cannot use. Tell us what has gone wrong using the form below.</div>'
        : '<div class="rp-note">The ' + esc(v.label) + ' parts list is briefly unavailable. '
          + 'The parts are still supported. Tell us what you need using the form below and we will '
          + 'come back to you with what we have.</div>';
      prefillForm(v.label, '');
      return;
    }
    $('rp-grid-hint').textContent = DATA.copy.step3_hint || '';
    var groups = GROUP_ORDER.filter(function (name) {
      return v.parts.some(function (p) { return p.g === name; });
    });
    g.innerHTML = groups.map(function (name) {
      var list = v.parts.filter(function (p) { return p.g === name; });
      return '<div class="rp-grp"><div class="rp-grpbar"><h3>' + esc(name) + '</h3>'
        + '<span class="rp-cnt">' + list.length + ' component' + (list.length === 1 ? '' : 's') + '</span></div>'
        + '<div class="rp-parts">' + list.map(card).join('') + '</div></div>';
    }).join('');
    wireGrid(g);
  }
  function card(p) {
    var n = qty[p.id] || 1;
    /* The photo and the name open the part on its product page, with that
       variant selected. The quantity, Add and Notify buttons stay siblings
       of the links, never inside them, so they keep working on the tile. */
    var href = p.u ? esc(p.u) : '';
    var plateTag = href ? 'a' : 'div';
    var plateAttr = href ? ' href="' + href + '" aria-label="View ' + esc(p.n) + ' details"' : '';
    return '<div class="rp-part"><' + plateTag + ' class="rp-plate"' + plateAttr + '>'
      + (p.i ? '<img src="' + esc(p.i) + '" alt="' + esc(p.n) + '" loading="lazy">'
             : '<span class="rp-noimg">Photo coming soon</span>')
      + chip(p) + '</' + plateTag + '>'
      + '<div class="rp-info">'
      + (href ? '<a class="rp-nm" href="' + href + '">' + esc(p.n) + '</a>' : '<span class="rp-nm">' + esc(p.n) + '</span>')
      + (p.s ? '<span class="rp-sku">' + esc(p.s) + '</span>' : '')
      + '<span class="rp-pr">' + money(p.p) + '</span>'
      + (href ? '<a class="rp-more" href="' + href + '">View details</a>' : '')
      + '</div>'
      + '<div class="rp-act">'
      + (p.avail
        ? '<div class="rp-step"><button type="button" data-dec="' + p.id + '" aria-label="Fewer">&minus;</button>'
          + '<span class="rp-qv rp-mono" data-q="' + p.id + '">' + n + '</span>'
          + '<button type="button" data-inc="' + p.id + '" aria-label="More">+</button></div>'
          + '<button class="rp-add" type="button" data-add="' + p.id + '">Add</button>'
        : '<button class="rp-notify" type="button" data-ask="' + p.id + '">Notify me</button>')
      + '</div></div>';
  }
  function wireGrid(root) {
    var q = function (sel, fn) {
      Array.prototype.forEach.call(root.querySelectorAll(sel), fn);
    };
    q('[data-inc]', function (b) { b.addEventListener('click', function () { bump(b.dataset.inc, 1); }); });
    q('[data-dec]', function (b) { b.addEventListener('click', function () { bump(b.dataset.dec, -1); }); });
    q('[data-add]', function (b) { b.addEventListener('click', function () { addPart(b.dataset.add, b); }); });
    q('[data-ask]', function (b) { b.addEventListener('click', function () { askAbout(b.dataset.ask); }); });
  }
  function findPart(id) {
    id = String(id);
    var hit = null;
    ed().parts.forEach(function (p) { if (String(p.id) === id) hit = p; });
    return hit;
  }
  function bump(id, d) {
    var p = findPart(id); if (!p) return;
    var max = (p.tracked && p.q > 0) ? p.q : 99;
    qty[p.id] = Math.max(1, Math.min(max, (qty[p.id] || 1) + d));
    var el = document.querySelector('[data-q="' + p.id + '"]');
    if (el) el.textContent = qty[p.id];
  }
  function addPart(id, btn) {
    var p = findPart(id); if (!p || !p.avail) return;
    cart[p.id] = (cart[p.id] || 0) + (qty[p.id] || 1);
    META[p.id] = p;
    var was = btn.textContent;
    btn.textContent = 'Added';
    setTimeout(function () { btn.textContent = was; }, 1100);
    renderBar();
  }
  function renderBar() {
    var keys = Object.keys(cart);
    var n = keys.reduce(function (a, k) { return a + cart[k]; }, 0);
    var t = keys.reduce(function (a, k) { return a + cart[k] * META[k].p; }, 0);
    $('rp-ct').textContent = n ? (n + ' part' + (n === 1 ? '' : 's') + ' selected') : 'Nothing selected';
    $('rp-tot').textContent = money(t);
    $('rp-go').disabled = !n;
    $('rp-lines').textContent = keys.map(function (k) { return cart[k] + ' x ' + META[k].n; }).join('   /   ');
    /* The bar is a fixed overlay. On a phone an empty one costs about a
       fifth of the screen for nothing, so it only appears once something
       is in it, and the page reserves exactly its height while it is up. */
    var bar = $('rp-bar'), root = document.querySelector('.agrp');
    if (bar) {
      bar.hidden = ed().request || !ed().parts.length || !n;
      if (root) root.style.paddingBottom = bar.hidden ? '' : (bar.offsetHeight + 12) + 'px';
    }
  }

  /* ---------- contact form reuse ---------- */
  function prefillForm(edition, partLabel) {
    var e = $('rp-f-edition'), p = $('rp-f-part');
    if (e) e.value = edition || '';
    if (p) p.value = partLabel || '';
  }
  function askAbout(id) {
    var p = findPart(id); if (!p) return;
    var label = p.n + (p.s ? ' (' + p.s + ')' : '');
    prefillForm(ed().label, label);
    var body = $('rp-what');
    if (body && !body.value.trim()) {
      body.value = 'Please let me know when the ' + label + ' for the ' + ed().label + ' is back in stock.';
    }
    focusForm();
  }
  function registerInterest(name) {
    prefillForm(ed().label, name);
    var body = $('rp-what');
    if (body && !body.value.trim()) {
      body.value = 'Please let me know when the ' + name + ' for the ' + ed().label + ' is available.';
    }
    focusForm();
  }
  function focusForm() {
    var target = $('rp-contact');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var nm = $('rp-name');
    if (nm) setTimeout(function () { nm.focus({ preventScroll: true }); }, 400);
  }

  /* ---------- handle identifier ---------- */
  function gripOf(part) {
    var m = /(\d{2})\s*mm/i.exec(part.n || '');
    return m ? parseInt(m[1], 10) : null;
  }
  function handles() {
    return ed().parts.filter(function (p) { return p.g === 'Handle assembly' && gripOf(p); });
  }
  function handleFor(mm) {
    var hit = null;
    handles().forEach(function (p) { if (gripOf(p) === mm) hit = p; });
    return hit;
  }
  function grips() {
    var seen = [];
    handles().forEach(function (p) {
      var mm = gripOf(p);
      if (seen.indexOf(mm) === -1) seen.push(mm);
    });
    return seen.sort(function (a, b) { return a - b; });
  }
  function dial() {
    var list = grips();
    if (!list.length) return '';
    var SCALE = 2.4, GAP = 30, PAD = 14, LABEL = 26;
    var rs = list.map(function (mm) { return mm / 2 * SCALE; });
    var maxR = Math.max.apply(null, rs);
    var cy = PAD + maxR;
    var h = cy + maxR + LABEL;
    var xs = [], x = PAD;
    rs.forEach(function (r) { xs.push(x + maxR); x += 2 * maxR + GAP; });
    var w = x - GAP + PAD;
    var parts = list.map(function (mm, i) {
      var r = rs[i], cx = xs[i], col = i === 0 ? 'var(--rp-accent)' : 'var(--rp-dim)';
      return '<circle cx="' + cx + '" cy="' + cy + '" r="' + r.toFixed(1) + '" fill="none" stroke="' + col + '" stroke-width="1.6"/>'
        + '<line x1="' + (cx - r).toFixed(1) + '" y1="' + cy + '" x2="' + (cx + r).toFixed(1) + '" y2="' + cy + '" stroke="' + col + '" stroke-width="1" stroke-dasharray="3 3"/>'
        + '<text x="' + cx + '" y="' + (cy + maxR + 18) + '" text-anchor="middle" font-size="12" fill="var(--rp-ink)" font-family="monospace">' + mm + 'mm</text>';
    }).join('');
    return '<svg width="' + Math.round(w) + '" height="' + Math.round(h) + '" viewBox="0 0 ' + Math.round(w) + ' ' + Math.round(h) + '" '
      + 'role="img" aria-label="Grip cross sections shown at relative scale">' + parts + '</svg>';
  }
  /* A dedicated reference photo beats the variant image here: the variant shot
     is a whole-dumbbell product picture where the grip is a few pixels wide,
     and the two grips historically shared the SAME file, so the tab showed one
     image twice and invited the customer to pick the wrong handle. */
  function gripPhoto(mm) {
    var hit = null;
    (DATA.grip_photos || []).forEach(function (g) { if (Number(g.mm) === mm && g.src) hit = g.src; });
    return hit;
  }
  function refImage(mm) {
    /* Deliberately NO fallback to the variant image. That image is a whole
       dumbbell thumbnail where the grip is a few pixels wide, so it can never
       answer "which grip is this", and on both editions the 34mm and 37mm
       variants point at byte-identical files anyway. Only a purpose-shot
       close-up belongs here. */
    return gripPhoto(mm);
  }
  /* Two Shopify uploads of the SAME file get different URLs: the second gets a
     uuid appended before the extension. Comparing raw URLs therefore says
     "distinct" for identical pictures, which is exactly how the first attempt
     at this guard failed. Normalise before comparing. */
  function normSrc(u) {
    if (!u) return '';
    var s2 = String(u).split('?')[0].split('#')[0];
    s2 = s2.substring(s2.lastIndexOf('/') + 1).toLowerCase();
    s2 = s2.replace(/\.(jpe?g|png|webp|gif|avif)$/, '');
    s2 = s2.replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/, '');
    s2 = s2.replace(/_\d+x\d*$/, '');
    return s2;
  }
  /* Show the comparison only when every grip has its own photo AND no two of
     them are the same picture. Anything less cannot answer the question. */
  function refsAreDistinct() {
    var list = grips(), seen = {};
    if (list.length < 2) return false;
    for (var i = 0; i < list.length; i++) {
      var k = normSrc(refImage(list[i]));
      if (!k || seen[k]) return false;
      seen[k] = 1;
    }
    return true;
  }
  /* ☠ The zoom control is a SIBLING of the select button, never a child of it.
     The tile itself is a <button>, and a <button> inside a <button> is invalid
     HTML: browsers do not nest them, they close the outer one, which silently
     breaks the tile. Hence the wrapper. */
  function lookTile(mm) {
    var src = refImage(mm);
    var gensAt = GENS.filter(function (g) { return g.mm === mm; }).map(function (g) { return g.b; });
    return '<div class="rp-cmp-item">'
      + '<button type="button" data-look="' + mm + '" aria-pressed="' + (!!verdict && verdict.mm === mm) + '">'
      + (src ? '<img src="' + esc(src) + '" alt="' + mm + 'mm grip, close up of the knurling" loading="lazy">'
             : '<span class="rp-noimg" style="aspect-ratio:4/3;display:grid;place-items:center;background:var(--rp-plate)">Reference photo coming soon</span>')
      + '<span class="rp-lb">' + mm + 'mm grip<small>' + esc(gensAt.join(', ') || 'and newer') + '</small></span></button>'
      + (src ? '<button type="button" class="rp-zoom" data-zoom="' + esc(src) + '" data-zoomlabel="' + mm + 'mm grip"'
             + ' aria-label="Enlarge the ' + mm + 'mm grip photo">'
             + '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true" focusable="false">'
             + '<circle cx="11" cy="11" r="6.5" fill="none" stroke="currentColor" stroke-width="2"/>'
             + '<path d="M15.8 15.8 21 21M11 8.6v4.8M8.6 11h4.8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>'
             + '</svg></button>' : '')
      + '</div>';
  }

  /* Full-screen look at one reference photo. The tile tap SELECTS a grip, so
     enlarging needs its own control rather than overloading that tap. */
  function openZoom(src, label) {
    var ov = document.createElement('div');
    ov.className = 'rp-lightbox';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-label', label + ', enlarged');
    ov.innerHTML = '<button type="button" class="rp-lb-x" aria-label="Close">&times;</button>'
      + '<img src="' + esc(src) + '" alt="' + esc(label) + ', enlarged">';
    function close() {
      document.removeEventListener('keydown', onKey);
      if (ov.parentNode) ov.parentNode.removeChild(ov);
      document.documentElement.style.overflow = prevOverflow;
      if (opener && opener.focus) opener.focus();   // put focus back where it was
    }
    function onKey(e) { if (e.key === 'Escape' || e.key === 'Esc') close(); }
    var opener = document.activeElement;
    var prevOverflow = document.documentElement.style.overflow;
    ov.addEventListener('click', function (e) {
      // Anywhere except the photo itself closes, which is what people try first.
      if (e.target === ov || e.target.classList.contains('rp-lb-x')) close();
    });
    document.addEventListener('keydown', onKey);
    document.documentElement.style.overflow = 'hidden';  // no scrolling the page behind it
    document.body.appendChild(ov);
    var x = ov.querySelector('.rp-lb-x');
    if (x && x.focus) x.focus();
  }
  function renderPanel() {
    var p = $('rp-panel');
    if (!p) return;
    if (ed().request || !handles().length) { p.innerHTML = ''; return; }
    var list = grips();
    if (tab === 'gen') {
      p.innerHTML = '<p class="rp-q">Every handle we sell fits every generation we have made. Your generation just '
        + 'tells us which grip you have now, so you can match it or switch. It is on your original order confirmation.</p>'
        + '<div class="rp-gens">'
        + GENS.map(function (g, i) {
            return '<button class="rp-gen" type="button" data-gen="' + i + '" aria-pressed="' + (genPick === i) + '">'
              + '<b>' + esc(g.b) + '</b><span>' + g.mm + 'mm grip</span></button>';
          }).join('')
        + '<button class="rp-gen" type="button" data-gen="-1" aria-pressed="false"><b>Not sure</b><span>try another route</span></button>'
        + '</div><div id="rp-vd"></div>';
      Array.prototype.forEach.call(p.querySelectorAll('[data-gen]'), function (btn) {
        btn.addEventListener('click', function () {
          var i = parseInt(btn.dataset.gen, 10);
          if (i < 0) { tab = 'look'; renderTabs(); renderPanel(); return; }
          genPick = i;
          verdict = { mm: GENS[i].mm, via: GENS[i].b };
          renderPanel();
        });
      });
    } else if (tab === 'look') {
      var distinct = refsAreDistinct();
      p.innerHTML = (distinct
          ? '<p class="rp-q">Hold your dumbbell next to these and look at the knurled section in the middle of the grip.</p>'
          : '<p class="rp-q">We do not have a clear side by side for these grips yet, so this route cannot tell them apart. Measure it instead, which is exact.</p>')
        + (distinct ? '<div class="rp-cmp">' + list.map(lookTile).join('') + '</div>' : '')
        + '<div class="rp-gens" style="margin-top:15px">'
        + '<button class="rp-gen" type="button" data-goto="meas"><b>Still not sure</b><span>measure it instead</span></button>'
        + '</div><div id="rp-vd"></div>';
      wireLook(p, 'visual match');
    } else {
      var lo = list[0], hi = list[list.length - 1];
      var cutD = Math.round((lo + hi) / 2);
      var circ = function (mm) { return Math.round(Math.PI * mm); };
      /* The uploaded guides already carry the how-to in the picture, so
         repeating it underneath is noise. The cut-off rule is NOT in the
         picture though, it is derived from the grip sizes, so it always
         shows. With no picture the full steps are the only instructions
         there are, so they come back. */
      var steps = function (img, own, rule) {
        if (img) return '<p class="rp-rule">' + rule + '</p>';
        return '<ol class="rp-steps">'
          + own.concat([rule]).map(function (t) { return '<li>' + t + '</li>'; }).join('')
          + '</ol>';
      };
      var shot = function (url, alt) {
        return url ? '<img class="rp-mimg" src="' + esc(url) + '" alt="' + esc(alt) + '" loading="lazy">'
                   : '<div class="rp-ph">Photo coming soon</div>';
      };
      /* The rule line above already maps a reading to a grip, so the buttons
         are just the answer. Repeating "Under 36mm" on the button made the
         customer re-do that mapping at the moment of choosing. */
      var btns = function () {
        return '<div class="rp-gens">'
          + '<button class="rp-gen" type="button" data-look="' + lo + '"><b>' + lo + 'mm grip</b></button>'
          + '<button class="rp-gen" type="button" data-look="' + hi + '"><b>' + hi + 'mm grip</b></button>'
          + '</div>';
      };
      p.innerHTML = '<p class="rp-q">The grips are only ' + (hi - lo) + 'mm apart, so this is the one to trust if you want to be certain. '
        + 'Use whichever method you have the tools for. Both give the same answer.</p>'
        + '<div class="rp-methods">'
        + '<div class="rp-method"><span class="rp-mtag">Method 1</span><h4>Measure across the grip</h4>'
        + shot(DATA.measure_across_image, 'Measuring across the grip with a caliper')
        + steps(DATA.measure_across_image,
            ['Lay a caliper or ruler across the middle of the knurled grip, at its widest point.',
             'Measure straight across the centre, not around the outside.'],
            'Under ' + cutD + 'mm is the ' + lo + 'mm grip. ' + cutD + 'mm or over is the ' + hi + 'mm grip.')
        + btns() + '</div>'
        + '<div class="rp-method"><span class="rp-mtag">Method 2</span><h4>No caliper? Measure around it</h4>'
        + shot(DATA.measure_around_image, 'Wrapping a tape around the grip')
        + steps(DATA.measure_around_image,
            ['Wrap a tape measure, a strip of paper or a piece of string right around the grip.',
             'Mark where it meets and read the length. That is the circumference.'],
            circ(lo) + 'mm is the ' + lo + 'mm grip. ' + circ(hi) + 'mm is the ' + hi
              + 'mm grip. Go with whichever is closer.')
        + btns() + '</div>'
        + '</div>'
        + '<div class="rp-scale">' + dial() + '<span>The two grips at relative scale. The difference is small, which is why measuring beats guessing.</span></div>'
        + '<div id="rp-vd"></div>';
      wireLook(p, 'measured');
    }
    renderVerdict();
  }
  function wireGoto(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-goto]'), function (b) {
      b.addEventListener('click', function () { tab = b.dataset.goto; renderTabs(); renderPanel(); });
    });
  }
  function wireLook(root, via) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-look]'), function (btn) {
      btn.addEventListener('click', function () {
        verdict = { mm: parseInt(btn.dataset.look, 10), via: via };
        renderPanel();
      });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-zoom]'), function (btn) {
      btn.addEventListener('click', function (e) {
        /* Defensive, not load-bearing: the zoom is a SIBLING of the select
           button, so a click on it cannot bubble through that button and cannot
           change the answer today (verified in the browser: aria-pressed was
           unchanged either side of a zoom click). Kept so that wrapping the tile
           in a clickable container later cannot silently turn "look closer" into
           "change my answer". */
        e.preventDefault();
        e.stopPropagation();
        openZoom(btn.dataset.zoom, btn.dataset.zoomlabel || 'Grip photo');
      });
    });
    wireGoto(root);
  }
  function optCard(mm, cur) {
    var p = handleFor(mm);
    if (!p) return '';
    var isMatch = mm === cur, diff = mm - cur;
    return '<div class="rp-opt' + (isMatch ? ' rp-rec' : '') + '">'
      + '<span class="rp-bdg' + (isMatch ? '' : ' rp-alt') + '">' + (isMatch ? 'Like for like' : 'Different grip') + '</span>'
      + '<h4>' + esc(p.n) + '</h4>'
      + '<span class="rp-meta">' + (p.s ? esc(p.s) + ' / ' : '') + stateText(p) + '</span>'
      + '<p class="rp-nt">' + (isMatch
        ? 'The same ' + mm + 'mm grip you have now, so a replaced handle still matches its pair.'
        : 'Fits your set too. The grip is ' + Math.abs(diff) + 'mm ' + (diff < 0 ? 'slimmer' : 'thicker')
          + ' than yours, so buy a pair if you want both to feel the same.')
      + '</p><div class="rp-row"><span class="rp-pz">' + money(p.p) + '</span>'
      + (p.avail ? '<button class="rp-add" type="button" data-vadd="' + p.id + '">Add</button>'
                 : '<button class="rp-notify" type="button" data-ask="' + p.id + '">Notify me</button>')
      + '</div></div>';
  }
  function soonStrip(cur) {
    return (DATA.upcoming || []).map(function (u) {
      var diff = u.mm ? u.mm - cur : null;
      return '<div class="rp-soonstrip"><span class="rp-bdg rp-alt">In development</span>'
        + '<span class="rp-tx"><b>' + esc(u.n) + '</b> is on the way for ' + esc(ed().label) + '.'
        + (diff ? ' It will be ' + Math.abs(diff) + 'mm ' + (diff < 0 ? 'slimmer' : 'thicker') + ' than your grip.' : '')
        + (u.blurb ? ' ' + esc(u.blurb) : '')
        + '</span><button class="rp-notify" type="button" data-interest="' + esc(u.n) + '">Register interest</button></div>';
    }).join('');
  }
  function renderVerdict() {
    var v = $('rp-vd');
    if (!v) return;
    if (!verdict) {
      v.innerHTML = '';
      $('rp-id-hint').textContent = 'Only needed if you are replacing a handle.';
      return;
    }
    var cur = verdict.mm;
    var others = grips().filter(function (m) { return m !== cur; });
    $('rp-id-hint').textContent = 'You have the ' + cur + 'mm grip';
    v.innerHTML = '<div class="rp-verdict"><div class="rp-rd"><b>You have a ' + cur + 'mm grip</b>'
      + '<span>identified by ' + esc(verdict.via) + ' / every handle below fits your set</span></div></div>'
      + '<div class="rp-opts">' + optCard(cur, cur) + others.map(function (m) { return optCard(m, cur); }).join('') + '</div>'
      + soonStrip(cur);
    Array.prototype.forEach.call(v.querySelectorAll('[data-vadd]'), function (b) {
      b.addEventListener('click', function () { addPart(b.dataset.vadd, b); });
    });
    Array.prototype.forEach.call(v.querySelectorAll('[data-ask]'), function (b) {
      b.addEventListener('click', function () { askAbout(b.dataset.ask); });
    });
    Array.prototype.forEach.call(v.querySelectorAll('[data-interest]'), function (b) {
      b.addEventListener('click', function () { registerInterest(b.dataset.interest); });
    });
  }
  function renderTabs() {
    Array.prototype.forEach.call(document.querySelectorAll('.agrp .rp-tab'), function (t) {
      t.setAttribute('aria-selected', String(t.dataset.tab === tab));
    });
  }

  /* ---------- cart ---------- */
  function submitCart() {
    var btn = $('rp-go');
    var items = Object.keys(cart).map(function (k) {
      return { id: parseInt(k, 10), quantity: cart[k] };
    });
    if (!items.length) return;
    btn.disabled = true;
    btn.textContent = 'Adding';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart add ' + r.status);
      window.location.href = '/cart';
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'Add all to cart';
      var hint = $('rp-lines');
      if (hint) hint.textContent = 'We could not add those just now. Please try again, or refresh the page.';
    });
  }

  /* ---------- boot ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('.agrp .rp-tab'), function (t) {
    t.addEventListener('click', function () { tab = t.dataset.tab; renderTabs(); renderPanel(); });
  });
  $('rp-go').addEventListener('click', submitCart);
  renderEds(); renderGrid(); renderTabs(); renderPanel(); renderBar();
})();
